<template>
  <div class="page-wrapper">
    <div class="section-container">
      <div class="overview-dash" v-if="dashboard_data">
        <widgetCounter title="Total Users" :value="dashboard_data.total_user" @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-1.svg" />
        </widgetCounter>
        <widgetCounter title="Total Movies" :value="dashboard_data.total_movies" @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-2.svg" />
        </widgetCounter>

        <widgetCounter title="Users Payed By MOMO" :value="dashboard_data.total_payed_momo" @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-4.svg" />
        </widgetCounter>
        <widgetCounter title="Users Payed by Spenn" :value="dashboard_data.total_payed_spenn" @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-5.svg" />
        </widgetCounter>
        <widgetCounter title="Users Payed by Card" :value="dashboard_data.total_payed_card" @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-6.svg" />
        </widgetCounter>
        <widgetCounter title="Movies Money" :value="'RWF ' + dashboard_data.total_movie_money_made" @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-3.svg" />
        </widgetCounter>

        <widgetCounter title="Streaming money" :value="'RWF' + dashboard_data.total_streaming_money_made"
          @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-1.svg" />
        </widgetCounter>

        <widgetCounter title="Live Watching" :value="live_watching" @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-2.svg" />
        </widgetCounter>
        <widgetCounter title="Movies Watching" :value="movies_watching" @more="() => { }">
          <img src="@/assets/images/dashboard/Graph-3.svg" />
        </widgetCounter>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data: () => ({
    dashboard_data: null,
    movies_watching: 0,
    live_watching: 0,
  }),
  sockets: {
    // connect: function () {},
    // watchLiveWatching: function (payload) {
    //   let vm = this;
    //   vm.live_watching = payload.users;
    // },
    // watchMoviesWatching: function (payload) {
    //   let vm = this;
    //   vm.movies_watching = payload.users;
    // },
  },
  watch: {},
  mounted() {
    let vm = this;
    if (vm.$getLoggedUser()) {
      let account_type = vm.$getLoggedUser().user.account_type;
      if (account_type == "streamer") {
        vm.$localStorage.set("redirect_path", "s_dashboard");
        vm.$appRedirect();
      } else {
        // vm.getDashbaordData();
        // setInterval(() => {
        //   if (vm.$route.name == "dashboard") {
        //     vm.getDashbaordData();
        //   }
        // }, 10000);
      }
    } else {
      vm.$router.push("/login");
    }
  },
  methods: {
    getDashbaordData() {
      let vm = this;
      vm.$store
        .dispatch("GET_DASHBOARD_DATA")
        .then((response) => {
          vm.dashboard_data = response.data.return;
        })
        .catch((error) => {
          console.log("GET_DASHBOARD_DATA", { error });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;


  .section-container {
    display: flex;
    height: 100%;
    flex-direction: column;
    padding: 15px;

    .overview-dash {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;

      .widget-counter {
        width: calc(33.333% - 10px);
        margin-bottom: 10px;
      }
    }
  }
}
</style>
